import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'numberFormat',
  standalone: true,
})
export class NumberFormatPipe implements PipeTransform {
  transform(value: number | null | undefined): string {
    if (value == null) return '0';
    const abs = Math.abs(value);
    return abs.toLocaleString('de-DE');
  }
}
